import { Component, OnInit, TemplateRef } from "@angular/core";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { AppState } from "@app/app.reducer";
import { isMobile } from "@app/shared/ngrx/shared.reducer";
import { select, Store } from "@ngrx/store";
import { Observable } from "rxjs";

@Component({
  selector: "app-q-sheet-wrapper",
  templateUrl: "./q-sheet-wrapper.component.html",
  styleUrls: ["./q-sheet-wrapper.component.scss"],
})
export class QSheetWrapperComponent implements OnInit {
  isMobile$: Observable<boolean>;

  constructor(
    private store: Store<AppState>,
    private _bottomSheet: MatBottomSheet
  ) {}

  ngOnInit(): void {
    this.isMobile$ = this.store.pipe(select(isMobile));
  }

  openSheet(sheet: TemplateRef<any>) {
    this._bottomSheet.open(sheet, { panelClass: "sheet-container" });
  }

  closeSheet() {
    this._bottomSheet.dismiss();
  }
}
